// @ts-strict-ignore
import styled from "styled-components";

export const RecaptchaTextContainer = styled.div`
  margin-top: 16px;
  margin-bottom: 20px;
  max-width: 264px;
  a {
    color: ${({ theme }) => theme.textColors.secondary};
  }
  ${({ theme: { media } }) => media.desktop`
   margin-top: 10px;
  `}
`;
